import { IReview } from "../_types"
import { request } from "./http-client"
import { TParams } from "./types"

const reviewService = {
  getList: (params: TParams, shipper_id?: string) =>
    request.get<{ reviews: IReview[]; count: string }>("/v1/user_reviews", {
      params,
      headers: shipper_id ? { Shipper: shipper_id } : undefined,
    }),
  create: (params: TParams) => request.post("/v1/user_reviews", params),
  free: (params: TParams) => request.post("/v1/user_reviews/free", params),
  getByBranch: (id: string, params: TParams) => request.get<{ reviews: IReview[]; count: string }>(`/v1/user_reviews/branches/${id}`, { params }),
}

export default reviewService
